export const MainPageComponent = {
  Component: null as any,
};
